module.exports = __webpack_public_path__ + "static/img/Lachie_Hunter_mobile.98a87b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lachie_Hunter_mobile.jpg
// module id = FR/Y
// module chunks = 0